/* eslint-disable */
import { useParams } from 'react-router-dom';
import { Search as NestedMenu } from './views/Search/Search';

export const Search: React.FC = ({}) => {
	const params = useParams();

	return (
		<div className="container mx-md-auto">
			<div className="menu pt-1 pt-sm-2 pt-md-3 pt-lg-5 menu-menu">
				<h1 className="text-center pb-3 display-3 text-secondary mb-lg-5 mb-md-3 mb-0 mb-sm-1">
					Search Results
				</h1>
				<NestedMenu id={`${params.groupId}`} />
			</div>
		</div>
	);
};
